import { render } from "./HomePageBannerSlide.vue?vue&type=template&id=10ffa429&scoped=true"
import script from "./HomePageBannerSlide.vue?vue&type=script&lang=js"
export * from "./HomePageBannerSlide.vue?vue&type=script&lang=js"

import "./HomePageBannerSlide.vue?vue&type=style&index=0&id=10ffa429&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ffa429"]])

export default __exports__